<div class="dialogShell">
    <div class="dialogHeader">
        <div class="dialogTitle">Add Item</div>
        <button mat-icon-button type="button" (click)="close()" aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialogBody">
        <mat-form-field appearance="outline" class="searchField">
            <mat-label>Search item</mat-label>
            <input #searchInput matInput [ngModel]="searchText" (ngModelChange)="onSearchChange($event)"
                placeholder="Type to search..." />
        </mat-form-field>

        <div class="hint" *ngIf="!searchText?.trim()">Type to search items.</div>
        <div class="hint" *ngIf="isLoading">Searching...</div>
        <div class="error" *ngIf="errorMessage">{{ errorMessage }}</div>

        <div class="results" *ngIf="!isLoading && searchText?.trim()">
            <div class="empty" *ngIf="results?.length === 0">No items found.</div>

            <button type="button" class="resultRow" *ngFor="let r of results" (click)="selectItem(r)">
                <!-- ✅ Image on left -->
                <div class="item-image">
                    <img *ngIf="r?.itemFusionId"
                        [src]="'http://mess-images.s3.ap-south-1.amazonaws.com/medium/' + r?.itemFusionId + '.jpg'"
                        [alt]="r?.itemName || ''" (error)="onImageError($event)" />
                    <!-- ✅ fallback placeholder if no image -->
                    <div class="no-image" *ngIf="!r?.itemFusionId">
                        <i class="fa fa-image"></i>
                    </div>
                </div>
                <div class="item-details">
                    <div class="name">{{ r?.itemName || r?.name || r?.label }}</div>
                    <div class="name">{{ r?.teluguItemName || r?.name || r?.label }}</div>
                    <div class="meta" *ngIf="r?.itemId">ID: {{ r?.itemId }}</div>
                </div>

            </button>
        </div>
    </div>
</div>

<!-- ================================ loader ======================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>